<template>
    <div class="type-of-realty mb-2 mb-xl-0">
        <input :id="id" type="radio" :name="name" :value="value" :checked="selected" class="type-of-realty__input"
               @change="updateValue($event.target.value)" required>
        <label :for="id"
               class="card card--hover card--no-shadow text-center mb-2 mb-md-0 h-100 d-block type-of-realty__label">
            <div class="card-body">
                <div :class="'realty-icon realty-icon--' + image"></div>
                <h3 class="type-of-realty__card-title">
                    {{ propertyName }}
                </h3>
                <span class="btn btn-outline-secondary type-of-realty__btn-select">
                {{ $t("buttons.choose") }}
            </span>
                <span class="btn btn-primary type-of-realty__btn-selected">
                <i class="fas fa-check mr-1"></i>
                    {{ $t("buttons.chosen") }}

            </span>
            </div>
        </label>
    </div>
</template>

<script>
export default {
    name: "RadioImageButton",
    props: {
        id: {
            type: String,
        },
        name: {
            type: String,
            required: true
        },
        value: {
            type: String,
            required: true
        },
        propertyName: {
            type: String,
            required: true
        },
        image: {
            type: String,
            required: true
        },
        selected: {
            type: Boolean,
            required: true
        }
    },
    methods: {
        updateValue: function (value) {
            this.$emit('update:value', value);
        }
    }
}
</script>

<style scoped>

</style>
